import {createSvgIcon} from '../create-svg-icon';

export const UpgradeIcon = createSvgIcon(
  <path d="M16 18v2H8v-2h8zM11 7.99V16h2V7.99h3L12 4 8 7.99h3z" />
, 'UpgradeOutlined');
